module.exports = __webpack_public_path__ + "img/Wallet-Related.95ea6a20.svg";